import { useEffect, type EffectCallback } from 'react'
/** Mount-only integration with browser resources; callers keep changing values in refs. */
export function useMountEffect(effect: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- This helper explicitly owns a mount-only lifecycle.
  useEffect(effect, [])
}
